import PlaceholderText from '../../../common/components/placeholder/PlaceholderText';
import {PaymentAddress} from '../../../interfaces/payment-address';

interface PaymentAddressDetailProps {
    isFetching: boolean;
    paymentAddress: PaymentAddress;
}

const PaymentAddressDetail = ({
    isFetching,
    paymentAddress: {name, address, city, zipCode, country},
}: PaymentAddressDetailProps): JSX.Element => {
    return (
        <div className="d-flex flex-column">
            <div className="d-flex fs-5 fw-bold mb-5">
                <PlaceholderText
                    isFetching={isFetching}
                    placeholderProps={{widthClassName: 'col-6'}}
                >
                    {name}
                </PlaceholderText>
            </div>
            <div className="fs-6 fw-semibold text-gray-600">
                <PlaceholderText
                    isFetching={isFetching}
                    placeholderProps={{widthClassName: 'col-8'}}
                >
                    {address}
                    <br />
                </PlaceholderText>
                <PlaceholderText
                    isFetching={isFetching}
                    placeholderProps={{widthClassName: 'col-6'}}
                >
                    {zipCode} {city}
                    <br />
                </PlaceholderText>
                <PlaceholderText
                    isFetching={isFetching}
                    placeholderProps={{widthClassName: 'col-5'}}
                >
                    {country}
                </PlaceholderText>
            </div>
        </div>
    );
};

export default PaymentAddressDetail;
